/**
 * Barre de filtres desktop de la page collection.
 *
 * Le contenu des <details> est re-rendu par facets.js apres chaque requete de
 * filtrage : tout est donc delegue au document, jamais attache aux elements
 * remplaces.
 *
 * Trois comportements seulement :
 *  - un seul menu ouvert a la fois ;
 *  - fermeture au clic en dehors et a l'echappement ;
 *  - mise a jour du compteur du menu qu'on vient d'utiliser (facets.js ne
 *    re-rend pas le groupe d'ou part l'evenement, pour ne pas casser la
 *    saisie en cours).
 */
(() => {
  const GROUP = 'details.cvfb__group';

  const closeOthers = (current) => {
    document.querySelectorAll(`${GROUP}[open]`).forEach((group) => {
      if (group !== current) group.removeAttribute('open');
    });
  };

  const closeAll = () => {
    document.querySelectorAll(`${GROUP}[open]`).forEach((group) => group.removeAttribute('open'));
  };

  /** Nombre de valeurs cochees, hors radios de tri (le tri n'a pas de badge). */
  const refreshCount = (group) => {
    const badge = group.querySelector('[data-facet-count]');
    if (!badge) return;

    const checked = group.querySelectorAll('input[type="checkbox"]:checked').length;
    const priceFields = group.querySelectorAll('.cvf__price-input');
    const hasPrice = [...priceFields].some((field) => field.value.trim() !== '');
    const total = checked || (hasPrice ? 1 : 0);

    badge.textContent = total;
    badge.hidden = total === 0;
  };

  document.addEventListener('toggle', (event) => {
    const group = event.target.closest?.(GROUP);
    if (!group || !group.open) return;
    closeOthers(group);
  }, true);

  document.addEventListener('click', (event) => {
    if (event.target.closest(GROUP)) return;
    closeAll();
  });

  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;
    const group = event.target.closest?.(GROUP);
    closeAll();
    if (group) group.querySelector('summary')?.focus();
  });

  document.addEventListener('change', (event) => {
    const group = event.target.closest?.(GROUP);
    if (!group) return;

    // Les pastilles refletent l'etat coche sans attendre le re-rendu.
    group.querySelectorAll('.cvf__pill').forEach((pill) => {
      const input = pill.querySelector('input');
      pill.classList.toggle('cvf__pill--active', Boolean(input && input.checked));
    });

    refreshCount(group);
  });
})();
